import { PriceUtils } from "@repo/common"
import * as React from "react"
import { useTranslations } from "use-intl"
import { ProductOrderingIndicator } from "./product-ordering-indicator"
import {
  SelectableCard,
  SelectableCardBadge,
  SelectableCardContent,
  SelectableCardHeader,
  SelectableCardIndicator,
  SelectableCardPrice,
  SelectableCardTitle,
} from "./selectable-card"

interface ProductAlternative {
  id: string
  title: string
  price: number
  ean: string | null
  isRecommended?: boolean
  needsOrdering?: boolean
  expectedDeliveryDate?: string | null
}

interface ServiceProposalProductChoiceCardProps {
  data: ProductAlternative
  selected: boolean
  onSelect: () => void
  interactive?: boolean
  className?: string
}

const ServiceProposalProductChoiceCard = React.forwardRef<
  HTMLDivElement,
  ServiceProposalProductChoiceCardProps
>(({ className, data, selected, onSelect, interactive = true }, ref) => {
  const t = useTranslations("ui")
  const shouldDimContent = !selected

  return (
    <SelectableCard
      ref={ref}
      className={className}
      selected={selected}
      onSelect={onSelect}
      interactive={interactive}
      color="secondary"
      variant="radio"
    >
      <SelectableCardHeader>
        <SelectableCardTitle className={shouldDimContent ? "opacity-40" : ""}>
          {data.title}
        </SelectableCardTitle>
        <SelectableCardIndicator />
      </SelectableCardHeader>

      <SelectableCardContent>
        <SelectableCardPrice
          className={`${shouldDimContent ? "opacity-40" : ""} text-lg font-semibold mt-1`}
        >
          {PriceUtils.format(data.price)}
        </SelectableCardPrice>
        {data.isRecommended && (
          <SelectableCardBadge>
            {t("readOnlyServiceProposal.recommended")}
          </SelectableCardBadge>
        )}
        {data.needsOrdering && (
          <ProductOrderingIndicator
            expectedDeliveryDate={data.expectedDeliveryDate}
          />
        )}
      </SelectableCardContent>
    </SelectableCard>
  )
})

ServiceProposalProductChoiceCard.displayName =
  "ServiceProposalProductChoiceCard"

export {
  ServiceProposalProductChoiceCard,
  type ServiceProposalProductChoiceCardProps,
}
